"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));

var _gatsby = require("gatsby");

var _stripeJs = require("@stripe/stripe-js");

var _useFormUrl = require("../../../src/hooks/use-form-url");

var _base64Url = _interopRequireDefault(require("base64-url"));

var _reactCopyToClipboard = require("react-copy-to-clipboard");

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var RECAPTCHA_KEY = process.env.GATSBY_SITE_RECAPTCHA_KEY;

var recaptchaRef =
/*#__PURE__*/
_react["default"].createRef();

var stripePromise = (0, _stripeJs.loadStripe)(process.env.GATSBY_STRIPE_PUBLISHABLE_KEY);

function Form(props) {
  var _useState = (0, _react.useState)("none"),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      display = _useState2[0],
      setDisplay = _useState2[1];

  var _useState3 = (0, _react.useState)("none"),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      copied = _useState4[0],
      setCopied = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      submitDisabled = _useState8[0],
      setSubmitDisabled = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      roi = _useState10[0],
      setRoi = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      encodeUrl = _useState12[0],
      setEncodeUrl = _useState12[1];

  var _useState13 = (0, _react.useState)(true),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      copyToClipboardDisabled = _useState14[0],
      setCopyToClipboardDisabled = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      description = _useState16[0],
      setDescription = _useState16[1];

  var _useState17 = (0, _react.useState)(0),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      amount = _useState18[0],
      setAmount = _useState18[1];

  var _useState19 = (0, _react.useState)(""),
      _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
      value = _useState20[0],
      setValue = _useState20[1];

  var langKey = props.langKey;
  var recaptchaError;
  var formUrlFinal;

  if (_useFormUrl.formUrl == "https://form.pradosdelsol.com/") {
    formUrlFinal = _useFormUrl.formUrl + "book";
  } else if (_useFormUrl.formUrl == "https://form.madmanpierre.com/") {
    formUrlFinal = _useFormUrl.formUrl + "contact";
  } else if (_useFormUrl.formUrl == "https://form.maintenanceconnection.ca/") {
    if (props.data.formType == "application") {
      formUrlFinal = _useFormUrl.formUrl + "applicationform";
    } else {
      formUrlFinal = _useFormUrl.formUrl + "contact";
    }
  }

  switch (langKey) {
    case "en":
      recaptchaError = "Please verify that you are not a robot!";
      break;

    case "es":
      recaptchaError = "Por favor verifique que no es un robot!";
      break;

    case "fr":
      recaptchaError = "Veuillez vérifier que vous n'êtes pas un robot!";
      break;
  }

  var handleRecaptcha =
  /*#__PURE__*/
  function () {
    var _ref = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee(value) {
      var recaptcha;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!value || value == "")) {
                _context.next = 8;
                break;
              }

              setSubmitDisabled(false);

              if (!(value == "")) {
                _context.next = 6;
                break;
              }

              setError(recaptchaError);
              setDisplay("block");
              return _context.abrupt("return");

            case 6:
              _context.next = 9;
              break;

            case 8:
              if (error && error === recaptchaError) {
                setError("");
                setDisplay("none");
              }

            case 9:
              recaptcha = {
                token: value
              };
              _context.next = 12;
              return fetch('/.netlify/functions/verify-recaptcha', {
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(recaptcha)
              }).then(function (res) {
                return res.json();
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleRecaptcha(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var validateRecaptcha = function validateRecaptcha() {
    var recaptchaValue = recaptchaRef.current.getValue();

    if (!recaptchaValue || recaptchaValue == "") {
      setSubmitDisabled(false);

      if (recaptchaValue == "") {
        setError(recaptchaError);
        setDisplay("block");
        return false;
      }
    } else {
      if (error && error === recaptchaError) {
        setError("");
        setDisplay("none");
      }

      return true;
    }
  };

  var handleDelete = function handleDelete() {
    if (display === "block") {
      setDisplay("none");
    }

    if (copied === "block") {
      setCopied("none");
    }
  };

  var handleDecode = function handleDecode(event) {
    event.preventDefault();
    var decodeParam = '';
    var separatorIndex = 0;
    decodeParam = value;
    decodeParam = decodeParam.replace(_useFormUrl.url, '').slice(1);
    decodeParam = _base64Url["default"].decode(decodeParam);
    separatorIndex = decodeParam.search("&");
    setDescription(decodeParam.substring(13, separatorIndex));
    setAmount(decodeParam.substring(separatorIndex + 9));
  };

  var handleSubmit =
  /*#__PURE__*/
  function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee2(event) {
      var data, totalSavings, details, _iterator, _step, pair, _data, encodeParam, _iterator2, _step2, _data2, checkoutResponse, sessionId, stripe, _yield$stripe$redirec, _error;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();

              if (!submitDisabled) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              setSubmitDisabled(true);

              if (!(props.data.formType === 'roi')) {
                _context2.next = 18;
                break;
              }

              data = new FormData(event.target);
              totalSavings = 0;
              data["delete"]('g-recaptcha-response');
              details = {};
              _iterator = _createForOfIteratorHelper(data.entries());

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  pair = _step.value;
                  details[pair[0]] = pair[1];
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              _context2.next = 13;
              return fetch('/.netlify/functions/calculate-roi', {
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  details: details
                })
              }).then(function (res) {
                return res.json();
              });

            case 13:
              totalSavings = _context2.sent;
              setRoi(totalSavings);
              setSubmitDisabled(false);
              _context2.next = 65;
              break;

            case 18:
              if (!(props.data.formType === 'urlEncrypt')) {
                _context2.next = 32;
                break;
              }

              _data = new FormData(event.target);

              _data["delete"]('encodeUrl');

              encodeParam = '';
              _iterator2 = _createForOfIteratorHelper(_data.entries());

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  pair = _step2.value;
                  encodeParam = encodeParam + pair[0] + '?=' + pair[1] + '&';
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }

              encodeParam = encodeParam.slice(0, -1);
              encodeParam = _base64Url["default"].encode(encodeParam);
              setEncodeUrl(_useFormUrl.url + '/' + encodeParam);
              setSubmitDisabled(false);
              setCopyToClipboardDisabled(false);
              setCopied("none");
              _context2.next = 65;
              break;

            case 32:
              if (!validateRecaptcha()) {
                _context2.next = 65;
                break;
              }

              _data2 = new FormData(event.target);

              _data2["delete"]('g-recaptcha-response');

              if (!(props.data.formType === "contact" || props.data.formType === "application")) {
                _context2.next = 40;
                break;
              }

              fetch(formUrlFinal, {
                method: 'POST',
                body: _data2,
                mode: 'no-cors'
              });
              (0, _gatsby.navigate)(langKey === "en" ? "/thanks" : "/" + langKey + "/thanks");
              _context2.next = 65;
              break;

            case 40:
              if (!(props.data.formType === "purchase" || props.data.formType === "book" || props.data.formType === "urlDecrypt")) {
                _context2.next = 65;
                break;
              }

              if (props.data.formType === "purchase" || props.data.formType === "urlDecrypt") {
                details = {
                  type: "purchase",
                  name: _data2.get("description"),
                  amount: Math.round(_data2.get("amount") * 100),
                  currency: _data2.get("currency"),
                  quantity: _data2.get("quantity"),
                  successUrl: langKey === "en" ? _useFormUrl.url + _useFormUrl.purchaseSuccessUrl : _useFormUrl.url + "/" + langKey + _useFormUrl.purchaseSuccessUrl,
                  cancelUrl: langKey === "en" ? _useFormUrl.url + _useFormUrl.purchaseCancelUrl : _useFormUrl.url + "/" + langKey + _useFormUrl.purchaseCancelUrl,
                  submitType: "pay",
                  langKey: langKey
                };
              } else if (props.data.formType === "book") {
                details = {
                  type: "room",
                  code: _data2.get("room"),
                  couponCode: _data2.get("coupon"),
                  quantity: 1,
                  successUrl: langKey === "en" ? _useFormUrl.url + _useFormUrl.bookSuccessUrl : _useFormUrl.url + "/" + langKey + _useFormUrl.bookSuccessUrl,
                  cancelUrl: langKey === "en" ? _useFormUrl.url + _useFormUrl.bookCancelUrl : _useFormUrl.url + "/" + langKey + _useFormUrl.bookCancelUrl,
                  submitType: "book",
                  langKey: langKey
                };
              }

              _context2.next = 44;
              return fetch('/.netlify/functions/create-checkout-session', {
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  details: details
                })
              }).then(function (res) {
                return res.json();
              });

            case 44:
              checkoutResponse = _context2.sent;

              if (!checkoutResponse.error) {
                _context2.next = 52;
                break;
              }

              setError(checkoutResponse.error);
              setDisplay("block");
              setSubmitDisabled(false);
              return _context2.abrupt("return");

            case 52:
              setError("");
              setDisplay("none");
              setSubmitDisabled(true);
              fetch(formUrlFinal, {
                method: 'POST',
                body: _data2,
                mode: 'no-cors'
              });
              sessionId = checkoutResponse.session.id;
              _context2.next = 59;
              return stripePromise;

            case 59:
              stripe = _context2.sent;
              _context2.next = 62;
              return stripe.redirectToCheckout({
                sessionId: sessionId
              });

            case 62:
              _yield$stripe$redirec = _context2.sent;
              _error = _yield$stripe$redirec.error;

              if (_error) {
                console.warn("Error:", _error);
              }

            case 65:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "content",
      style: {
        textAlign: 'center'
      }
    }, props.data.title != null ?
    /*#__PURE__*/
    _react["default"].createElement("p", {
      className: "has-text-weight-bold",
      style: {
        fontSize: '25px'
      }
    }, props.data.title) : null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "box"
    },
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement("form", {
      name: "contact",
      onSubmit: handleSubmit,
      "data-netlify-recaptcha": "true",
      className: "form"
    }, props.data.fieldGroups != null ?
    /*#__PURE__*/
    _react["default"].createElement("div", null, props.data.fieldGroups.map(function (fieldGroup) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_react["default"].Fragment, null,
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "".concat(fieldGroup.groupTitleSize, " has-text-weight-bold"),
          style: {
            textAlign: "".concat(fieldGroup.groupTitleAlign)
          }
        }, fieldGroup.groupTitle), fieldGroup.fieldRows.map(function (fieldRow) {
          return (
            /*#__PURE__*/
            _react["default"].createElement("div", {
              className: "field is-horizontal"
            },
            /*#__PURE__*/
            _react["default"].createElement("div", {
              className: "field-body"
            }, fieldRow.fields.map(function (field) {
              return (
                /*#__PURE__*/
                _react["default"].createElement(_react["default"].Fragment, null, field.type === "radio" && field.labelPosition === "left" &&
                /*#__PURE__*/
                _react["default"].createElement("label", {
                  className: "label",
                  style: {
                    textAlign: 'left'
                  }
                }, field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? "".concat(field.label, "*") : field.label),
                /*#__PURE__*/
                _react["default"].createElement("div", {
                  className: "field"
                },
                /*#__PURE__*/
                _react["default"].createElement("div", {
                  className: "control ".concat(field.hasIcon, " is-expanded ").concat(field.type === 'date' ? "" : "has-floating-label")
                }, field.type === "multiLineText" ?
                /*#__PURE__*/
                _react["default"].createElement(_react["default"].Fragment, null,
                /*#__PURE__*/
                _react["default"].createElement("textarea", {
                  className: "textarea is-small",
                  style: {
                    border: field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? '2px solid' : null
                  },
                  placeholder: " ",
                  name: field.name,
                  "aria-label": field.name,
                  required: field.isRequired,
                  id: field.name
                }),
                /*#__PURE__*/
                _react["default"].createElement("label", {
                  "class": "label is-floating-label",
                  "for": field.name
                }, field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? "".concat(field.placeholder, "*") : field.placeholder)) : null, field.type === "checkbox" ?
                /*#__PURE__*/
                _react["default"].createElement("label", {
                  className: "checkbox"
                },
                /*#__PURE__*/
                _react["default"].createElement("input", {
                  type: field.type,
                  style: {
                    marginRight: '0.5rem'
                  },
                  name: field.name,
                  "aria-label": field.name,
                  required: field.isRequired
                }), field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? "".concat(field.label, "*") : field.label) : null, field.type === "date" ?
                /*#__PURE__*/
                _react["default"].createElement(_react["default"].Fragment, null,
                /*#__PURE__*/
                _react["default"].createElement("label", {
                  className: "label",
                  style: {
                    textAlign: 'center'
                  }
                }, field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? "".concat(field.label, "*") : field.label),
                /*#__PURE__*/
                _react["default"].createElement("input", {
                  className: "input is-small is-date",
                  style: {
                    border: field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? '2px solid' : null
                  },
                  type: field.type,
                  name: field.name,
                  role: "date",
                  "aria-label": field.name,
                  required: field.isRequired
                })) : null, field.type === "select" ?
                /*#__PURE__*/
                _react["default"].createElement(_react["default"].Fragment, null, field.label != null ?
                /*#__PURE__*/
                _react["default"].createElement("label", {
                  className: "label",
                  style: {
                    textAlign: 'center'
                  }
                }, field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? "".concat(field.label, "*") : field.label) : null,
                /*#__PURE__*/
                _react["default"].createElement("div", {
                  className: "select is-fullwidth is-small"
                },
                /*#__PURE__*/
                _react["default"].createElement("select", {
                  style: {
                    border: field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? '2px solid' : null
                  },
                  name: field.name,
                  "aria-label": field.name,
                  required: field.isRequired
                }, field.options.map(function (option) {
                  return (
                    /*#__PURE__*/
                    _react["default"].createElement("option", {
                      value: option.code
                    }, option.label)
                  );
                })))) : null, field.type === "radio" ?
                /*#__PURE__*/
                _react["default"].createElement(_react["default"].Fragment, null, field.labelPosition === "top" &&
                /*#__PURE__*/
                _react["default"].createElement("label", {
                  className: "label",
                  style: {
                    textAlign: 'center'
                  }
                }, field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? "".concat(field.label, "*") : field.label),
                /*#__PURE__*/
                _react["default"].createElement("div", {
                  className: "control",
                  style: {
                    textAlign: 'center'
                  }
                }, field.options.map(function (option) {
                  return (
                    /*#__PURE__*/
                    _react["default"].createElement("label", {
                      className: "radio",
                      style: {
                        marginRight: '1rem'
                      }
                    },
                    /*#__PURE__*/
                    _react["default"].createElement("input", {
                      type: "radio",
                      value: option.code,
                      name: field.name,
                      style: {
                        marginRight: '0.5rem'
                      },
                      required: field.isRequired
                    }), option.label)
                  );
                }))) : null, field.type === "html" ?
                /*#__PURE__*/
                _react["default"].createElement("div", {
                  dangerouslySetInnerHTML: {
                    __html: "".concat(field.value)
                  }
                }) : null, field.type !== "checkbox" && field.type !== "multiLineText" && field.type !== "date" && field.type !== "select" && field.type !== "radio" && field.type !== "html" ?
                /*#__PURE__*/
                _react["default"].createElement(_react["default"].Fragment, null,
                /*#__PURE__*/
                _react["default"].createElement("input", {
                  className: "input is-small",
                  style: {
                    border: field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? '2px solid' : null
                  },
                  type: field.type,
                  placeholder: " ",
                  name: field.name,
                  "aria-label": field.name,
                  required: field.isRequired,
                  id: field.name,
                  step: field.type === "number" ? "0.01" : false,
                  readonly: field.isReadOnly,
                  disabled: field.isDisabled,
                  onChange: function onChange(event) {
                    return field.name === "decodeUrl" ? setValue(event.target.value) : null;
                  },
                  value: function () {
                    switch (field.name) {
                      case "totalSavings":
                        return "".concat(roi);

                      case "encodeUrl":
                        return "".concat(encodeUrl);

                      case "description":
                        if (props.data.formType === "urlDecrypt") {
                          return "".concat(description);
                        } else {
                          return null;
                        }

                        ;

                      case "amount":
                        if (props.data.formType === "urlDecrypt") {
                          return "".concat(amount);
                        } else {
                          return null;
                        }

                        ;

                      default:
                        return null;
                    }
                  }()
                }),
                /*#__PURE__*/
                _react["default"].createElement("label", {
                  "class": "label is-floating-label",
                  "for": field.name
                }, field.isRequiredFormat || field.isRequired && field.isRequiredFormat == null ? "".concat(field.placeholder, "*") : field.placeholder)) : null, field.icon != null ?
                /*#__PURE__*/
                _react["default"].createElement("span", {
                  className: "icon is-small is-left"
                },
                /*#__PURE__*/
                _react["default"].createElement("div", null, field.icon === "faUser" ?
                /*#__PURE__*/
                _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
                  icon: _freeSolidSvgIcons.faUser
                }) : null, field.icon === "faEnvelope" ?
                /*#__PURE__*/
                _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
                  icon: _freeSolidSvgIcons.faEnvelope
                }) : null, field.icon === "faPhone" ?
                /*#__PURE__*/
                _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
                  icon: _freeSolidSvgIcons.faPhone
                }) : null, field.icon === "faMapMarked" ?
                /*#__PURE__*/
                _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
                  icon: _freeSolidSvgIcons.faMapMarked
                }) : null, field.icon === "faMoneyBill" ?
                /*#__PURE__*/
                _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
                  icon: _freeSolidSvgIcons.faMoneyBill
                }) : null, field.icon === "faStickyNote" ?
                /*#__PURE__*/
                _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
                  icon: _freeSolidSvgIcons.faStickyNote
                }) : null, field.icon === "faInfoCircle" ?
                /*#__PURE__*/
                _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
                  icon: _freeSolidSvgIcons.faInfoCircle
                }) : null, field.icon === "faCoins" ?
                /*#__PURE__*/
                _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
                  icon: _freeSolidSvgIcons.faCoins
                }) : null)) : null)))
              );
            })))
          );
        }))
      );
    })) : null, props.data.hasRecaptcha ?
    /*#__PURE__*/
    _react["default"].createElement(_reactGoogleRecaptcha["default"], {
      ref: recaptchaRef,
      sitekey: RECAPTCHA_KEY,
      onChange: handleRecaptcha,
      style: {
        paddingTop: "0.75rem"
      },
      hl: langKey
    }) : null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "field",
      style: {
        paddingTop: "0.75rem",
        textAlign: "left"
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "control"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "buttons"
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      type: "submit",
      className: "button is-dark is-small",
      disabled: submitDisabled
    }, submitDisabled ? 'Loading...' : props.data.submitText), props.data.hasCopyToClipboard ?
    /*#__PURE__*/
    _react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
      text: encodeUrl,
      onCopy: function onCopy() {
        return setCopied("block");
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      type: "button",
      className: "button is-dark is-small",
      disabled: copyToClipboardDisabled
    }, "Copy to clipboard")) : null, props.data.hasDecode ?
    /*#__PURE__*/
    _react["default"].createElement("button", {
      type: "button",
      className: "button is-dark is-small",
      onClick: handleDecode
    }, "Decode") : null)))), props.data.hasCopyToClipboard ?
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        paddingTop: "0.75rem",
        display: "".concat(copied)
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "notification is-success"
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "delete",
      onClick: handleDelete
    }), "Copied")) : null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        paddingTop: "0.75rem",
        display: "".concat(display)
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "notification is-danger"
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "delete",
      onClick: handleDelete
    }), error)))))
  );
}

;
var _default = Form;
exports["default"] = _default;